import { useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';

export const useSettingsProfile = () => {
  const queryClient = useQueryClient();
  const { data } = queryClient.getQueryData(QUERY_KEYS.SETTINGS_PROFILE) || ({} as any);

  return { isRentersEnabled: data?.isRentersEnabled, settingsProfileData: data };
};
